/* eslint-disable max-len */
import { organizationusersList } from "./apiSlice";

const importList = organizationusersList.injectEndpoints({
    tagTypes: ['imports','Patient','Organization'],
    endpoints: (builder) => ({
        // downlaod the sample file api
        getImportSampleFile: builder.query({
            query: (queryParams) => ({
                url: `users/sample-file?${queryParams}`,
                method: 'GET',
            }),
            providesTags: ['Patient'], // Optional: useful for cache invalidation
        }),
        // import file validation api call
        importPatient:builder.mutation({
            query:org=>({
                url:`/patients/import-patients-validations`,
                method:'POST',
                body:org
            }),
        }),
        // import list api
        getImportList: builder.query({
            query: (queryParams) => ({
                url: `users/import-history?${queryParams}`,
                method: 'GET',
            }),
            providesTags:(result=[],error,arg)=>error===undefined?[
                
                'imports']:[]
        }),

        // import file validation api call for org user
        importOrgUser:builder.mutation({
            query:org=>({
                url:`/organization-users/organization-users-validation`,
                method:'POST',
                body:org
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetImportSampleFileQuery,
    useImportPatientMutation,
    useLazyGetImportListQuery,
    useImportOrgUserMutation,
    useGetImportListQuery,
} = importList;

export default importList;
